import React from 'react';
import Experiment from '@homeaway/react-experiment';
import CancelTripModal from '../CancelTripModal/CancelTripModal';
import ManageBookingSection from '../ManageBookingSection/ManageBookingSection';

const WithdrawBooking = (props) => {
    const {
        cancellationLabel,
        cancellationPoliciesNote,
        cancellationReasons,
        cancellationType,
        conversationId,
        fetch,
        filteredCategory,
        fullLocale,
        locale,
        shortDisplayName,
        translations,
    } = props;

    return (
        <ManageBookingSection data-testid="manage-booking-withdraw-booking">
            <div className="CancelSection__section-content-container CancelSection__section-content-container__withdrawal">
                <div className="CancelSection__section-content">
                    <p>{cancellationPoliciesNote}</p>
                </div>
                <div className="CancelSection__section-content">
                    <Experiment
                        name={'VRBO_STX_COVID_CANCELLATION_REASON'}
                        variant={'off'}
                    >
                        <CancelTripModal
                            cancellationReasonsByCategory={filteredCategory}
                            cancellationType={cancellationType}
                            conversationId={conversationId}
                            fullLocale={fullLocale}
                            locale={locale}
                            manageBookingLabel={cancellationLabel}
                            onComplete={fetch}
                            shortDisplayName={shortDisplayName}
                            translations={translations}
                        />
                    </Experiment>
                    <Experiment
                        name={'VRBO_STX_COVID_CANCELLATION_REASON'}
                        variant={'on'}
                    >
                        <CancelTripModal
                            cancellationReasonsByCategory={cancellationReasons}
                            cancellationType={cancellationType}
                            conversationId={conversationId}
                            fullLocale={fullLocale}
                            locale={locale}
                            manageBookingLabel={cancellationLabel}
                            onComplete={fetch}
                            shortDisplayName={shortDisplayName}
                            translations={translations}
                        />
                    </Experiment>
                </div>
            </div>
        </ManageBookingSection>
    );
};

export default WithdrawBooking;
